export enum FileWarning {
	TOO_MANY_FILES = 'tooManyFiles',
	WRONG_FORMAT = 'wrongFormat',
}
